import { NgClass } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'common-stepper',
	standalone: true,
	imports: [NgClass],
	templateUrl: './common-stepper.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./common-stepper.widget.scss']
})
export class CommonStepperWidget {

	public readonly totalStep = input.required<number>();
	public readonly currentStep = input.required<number>();
	public readonly displayNumbers = input<boolean>(false);

}